const module = { name: 'video/events', exports: {} }; const exports = module.exports;



const EventNames = {
    ON_END: 'take2player:OnReleaseEnd',
    PLACEHOLDER_CLICK: 'take2player:OnPlaceholderClick',
}
function addReleaseEndListener(cb) {
    window.addEventListener('message', (e) => {
        const data = e.message || e.data;
        if (data && data.name === EventNames.ON_END) {
            return cb(data);
        }
    }, false);
}
function addPlaceholderClickListener(cb) {
    window.addEventListener(EventNames.PLACEHOLDER_CLICK, e => cb(e.detail));
}
module.exports = {
    EventNames,
    onVideoEnd: addReleaseEndListener,
    onPlaceholderClick: addPlaceholderClickListener,
};
export default module.exports;